import PropTypes from 'prop-types';

const initialTournamentShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  position: PropTypes.number,
  isTop: PropTypes.bool,
  sportId: PropTypes.number.isRequired,
  sportName: PropTypes.string.isRequired,
  categoryId: PropTypes.number.isRequired,
  categoryName: PropTypes.string.isRequired,
});

export default initialTournamentShape;
